/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'chart': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" d="M40.18 16.15a2.81 2.81 0 0 1 2.82 2.8V44.2c0 1.55-1.26 2.8-2.82 2.8a2.81 2.81 0 0 1-2.82-2.8V18.95c0-1.55 1.26-2.8 2.82-2.8zM24.5 1a2.81 2.81 0 0 1 2.82 2.8v40.4c0 1.55-1.26 2.8-2.82 2.8a2.81 2.81 0 0 1-2.82-2.8V3.8c0-1.55 1.26-2.8 2.82-2.8zM8.82 26.25a2.81 2.81 0 0 1 2.82 2.8V44.2c0 1.55-1.26 2.8-2.82 2.8A2.81 2.81 0 0 1 6 44.2V29.05c0-1.54 1.26-2.8 2.82-2.8z" clip-rule="evenodd"/>'
  }
})
